/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Abandon_WarningInputs */



/**
* | output |
* | --- |
* | "They will need to claim the VEKN ID again or be re-linked by a coordinator." |
*
* @param {Vekn_Abandon_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_abandon_warning = /** @type {((inputs?: Vekn_Abandon_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Abandon_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il devra revendiquer à nouveau le VEKN ID ou être relié par un coordinateur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deberán reclamar el ID VEKN nuevamente o ser revinculados por un coordinador.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Eles precisarão reivindicar o VEKN ID novamente ou ser revinculados por um coordenador.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dovrà reclamare nuovamente il VEKN ID o essere ricollegato da un coordinatore.")
	return /** @type {LocalizedString} */ ("They will need to claim the VEKN ID again or be re-linked by a coordinator.")
});